// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocaleSwitch_wrapper__9Dvg7","checkmark":"LocaleSwitch_checkmark__WV_Wf","localeSwitch":"LocaleSwitch_localeSwitch__Nsx4C","lightMode":"LocaleSwitch_lightMode__QDh9X"};